import { PRESERVED_TERMS_CASE_ACRONYMS } from './constants'
import { isString } from '../../utils/checks'

const termToLowerCasePreservingAcronyms = (term) => {
  if (!isString(term)) {
    return ''
  }

  const normalizedTerm = term.toLowerCase()
  const acronym = PRESERVED_TERMS_CASE_ACRONYMS[normalizedTerm]

  if (!acronym) {
    return normalizedTerm
  }

  return normalizedTerm.replace(acronym.toLowerCase(), acronym)
}

export default termToLowerCasePreservingAcronyms
